import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router';

import { clientApi } from '@/components/Client/api';
import { getClientInfo, setClient } from '@/components/Client/client.store';
import { isInWebView } from '@/components/Client/shared/webview/env';
import {
  CLIENT_ROUTES,
  getFullClientRoute
} from '@/components/Shared/routes/routes';
import { getClientToken, removeClientToken } from '@/services/user-hash';
import { useAppDispatch, useAppSelector } from '@/store';

const ProtectedRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();
  const token = getClientToken();

  const { clientAdditionalInfo } = useAppSelector((state) => state.client);

  useEffect(() => {
    const client = getClientToken();
    const isAuthorized = client?.accessToken || clientApi.isSsoAuthorized();
    if (isAuthorized && !clientAdditionalInfo.initialValues) {
      dispatch(getClientInfo());
    }
  }, [clientAdditionalInfo]);

  const webviewMode = isInWebView();
  // В WebView гейт — по redux client (его выставляет AuthProvider после
  // SSO-авторизации), а не по web-токену: web-токена в WebView нет.
  const isAuthenticated = webviewMode
    ? !!clientApi.isSsoAuthorized()
    : !!token?.accessToken;

  if (!isAuthenticated) {
    if (!webviewMode) {
      removeClientToken();
      dispatch(setClient(null));
    }
    return (
      <Navigate
        to={`/${i18n.language}${getFullClientRoute(CLIENT_ROUTES.autoCreditCreate)}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
